/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskWithSubtasksResponseDto } from '../../models/core-project-task-with-subtasks-response-dto';

export interface ProjectTasksControllerFindCompleteByProjectId$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The project ID.
 */
  projectId: string;
}

export function projectTasksControllerFindCompleteByProjectId(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindCompleteByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindCompleteByProjectId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>;
    })
  );
}

projectTasksControllerFindCompleteByProjectId.PATH = '/o2-core/project-tasks/{tenant}/project/{projectId}/complete';
